import { create } from "zustand";
import { filter, findIndex } from "lodash";

import { Schedule } from "../types/schedule.types";

interface ScheduleStore {
  schedules: Array<Schedule>;
  setSchedules: (schedules: Array<Schedule>) => void;
  addORUpdateSchedule: (schedule: Schedule) => void;
  deleteSchedule: (scheduleId: string) => void;

  schedulesDone: object;
  markScheduleDone: (scheduleId: string) => void;
}

const SchedulesStore = create<ScheduleStore>((set) => ({
  schedulesDone: new Set(),
  schedules: [],

  setSchedules: (schedules: Array<Schedule>) => {
    set((state) => ({ ...state, schedules }));
  },

  addORUpdateSchedule: (schedule: Schedule) => {
    set((state) => {
      const newSchedules = [...state.schedules];
      const scheduleIndex = findIndex(
        newSchedules,
        (item) => item.playlist_id === schedule.playlist_id
      );

      if (scheduleIndex === -1) {
        const finalSchedule = [schedule, ...newSchedules];

        return { schedules: finalSchedule };
      } else {
        newSchedules[scheduleIndex] = schedule;
      }
      return { schedules: newSchedules };
    });
  },

  //! TODO: not needed
  deleteSchedule: (scheduleId: string) => {
    set((state) => {
      const newSchedules = filter(
        state.schedules,
        (schedule) => schedule.id !== scheduleId
      );
      return { schedules: newSchedules };
    });
  },

  markScheduleDone: (scheduleId: string) => {
    set((state) => {
      const updatedObject = { ...state.schedulesDone, [scheduleId]: true };
      return { schedulesDone: updatedObject };
    });
  },
}));

export default SchedulesStore;
